module.exports = __webpack_public_path__ + "static/img/icon_zj_09.4617a05e.png";